import Logo from '../../../assets/images/logos/logo.png';
import { GptMessage } from '../../components/chat-gpt/GptMessage';
import { TypingLoader } from '../../components/chat-gpt/typing-loader';
import { TextMessageBox } from '../../components/chat-gpt/TextMessageBox';
import { Box, Grid } from '@mui/material';
import { useAssistantPage } from './hook';
import { ChatHistory } from './ChatHistory';
import { ShowMessagesAndFiles } from './ShowMessagesAndFields';

export const AssistantPage = () => {
    const {
        messages,
        handlePost,
        isLoading,
        messagesEndRef,
        lastChats,
        handleSelectConversation,
        isOpenHistory,
        handleHistoryClose,
        anchorRef,
        options,
        selectedIndex,
        openOptionButton,
        handleClose,
        handleMenuItemClick,
        handleToggle,
        isVisibleButtons,
        onClickDownload,
        isAssistantAdvancedMode,
        displayName,
    } = useAssistantPage();

    return (
        <>
            <img src={Logo} alt="WarePilot logo" style={{ width: '10%' }} />
            <Box
                display="flex"
                height="85vh"
                flexDirection={isOpenHistory ? 'row' : 'column'}
            >
                <ChatHistory
                    isOpenHistory={isOpenHistory}
                    handleHistoryClose={handleHistoryClose}
                    lastChats={lastChats}
                    handleSelectConversation={handleSelectConversation}
                />
                <Box
                    width={isOpenHistory ? '80%' : 'auto'}
                    display="flex"
                    flexDirection="column"
                    flex="1 1 auto"
                    borderRadius={
                        isOpenHistory ? '0 16px 16px 0' : '0 0 16px 16px'
                    }
                    p={2}
                    bgcolor="rgba(23, 39, 192, 0.16)"
                    height={isOpenHistory ? 'auto' : '70vh'}
                >
                    <Box
                        display="flex"
                        flexDirection="column"
                        flex="1"
                        overflow="auto"
                        mb={2}
                    >
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <GptMessage
                                    children={`Buen día, soy **${displayName}**, ¿Cuál es tu nombre? y ¿en qué puedo ayudarte?`}
                                />
                            </Grid>

                            <ShowMessagesAndFiles
                                messages={messages}
                                onClickDownload={onClickDownload}
                            />

                            {isLoading && (
                                <Grid item xs={12} className="fade-in">
                                    <TypingLoader />
                                </Grid>
                            )}

                            <div ref={messagesEndRef} />
                        </Grid>
                    </Box>

                    <TextMessageBox
                        onSendMessage={handlePost}
                        placeholder="Escribe aquí lo que deseas"
                        disableCorrections
                        disable={isLoading}
                        isAdvancedMode={
                            selectedIndex === 1 || isAssistantAdvancedMode
                        }
                        anchorRef={anchorRef}
                        options={options}
                        selectedIndex={selectedIndex}
                        openOptionButton={openOptionButton}
                        handleClose={handleClose}
                        handleMenuItemClick={handleMenuItemClick}
                        handleToggle={handleToggle}
                        isVisibleButtons={isVisibleButtons}
                    />
                </Box>
            </Box>
        </>
    );
};
